import { CheckRegulatoryComplianceQuery } from '@/types/generated/graphql';

type CheckRegulatoryComplianceData = NonNullable<
  NonNullable<CheckRegulatoryComplianceQuery['checkRegulatoryCompliance']>['data']
>;

export type RegulatoryComplianceFieldRequirements = {
  isIdentityFieldRequired: boolean;
  isAddressFieldRequired: boolean;
  isInfoVisible: boolean;
};

export function deriveRegulatoryComplianceFieldRequirements(
  data: CheckRegulatoryComplianceData | null | undefined
): RegulatoryComplianceFieldRequirements {
  const isAddressRequired = data?.requiredRegulatoryCompliance?.address;
  const isAddressApproved = data?.approvedRegulatoryCompliance?.address;
  const isIdentityRequired = data?.requiredRegulatoryCompliance?.identity;
  const isIdentityApproved = data?.approvedRegulatoryCompliance?.identity;

  const isAddressFieldRequired = Boolean(data?.regulatoryCompliance) && isAddressRequired !== isAddressApproved;
  const isIdentityFieldRequired = Boolean(data?.regulatoryCompliance) && isIdentityRequired !== isIdentityApproved;

  return {
    isAddressFieldRequired,
    isIdentityFieldRequired,
    isInfoVisible: isAddressFieldRequired || isIdentityFieldRequired,
  };
}
